import type { CSSProperties } from 'react'

/**
 * 将条目按高度贪心塞进「当前累计高度最短」的一列，使各列总高度接近（瀑布流占位 / 预估高度排布）。
 * `gapPx` 须与列内 `flex flex-col gap-*` 的间距一致（如 gap-4 → 16，gap-3 → 12）。
 */
export function splitMasonryByShortestColumn<T>(
  items: readonly T[],
  columnCount: number,
  heightOf: (item: T) => number,
  gapPx: number,
): T[][] {
  const n = Math.max(1, Math.floor(columnCount))
  if (items.length === 0) return Array.from({ length: n }, () => [])
  const buckets: T[][] = Array.from({ length: n }, () => [])
  const sums = new Array(n).fill(0)
  for (const item of items) {
    let idx = 0
    for (let c = 1; c < n; c++) {
      if (sums[c] < sums[idx]) idx = c
    }
    buckets[idx].push(item)
    sums[idx] += heightOf(item) + gapPx
  }
  return buckets
}

/** 与图库瀑布容器一致：CSS Grid 等分列 */
export function masonryGridColumnsStyle(columns: number): CSSProperties {
  const n = Math.max(1, Math.floor(columns))
  return { gridTemplateColumns: `repeat(${n}, minmax(0, 1fr))` }
}
